export default __webpack_public_path__ + "static/media/motion-chat-logo.6177fa08.png";